import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tcp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Fire-and-forget route-event tracker. Feeds the data-driven Popular Routes
 * ranking on the landing page. Never awaits, never throws — UX must never
 * wait on or be affected by analytics.
 *   type: "view" (landed on /flights/:slug) | "click" (popular-routes card) | "search" (widget submit)
 */
export function trackRouteEvent(type, origin, destination) {
  if (!origin || !destination) return;
  try {
    api.post("/products/flights/events", {
      type, origin: String(origin).toUpperCase(), destination: String(destination).toUpperCase(),
    }).catch((e) => {
      // Analytics must never affect UX — log to console only.
      if (process.env.NODE_ENV !== "production") console.debug("trackRouteEvent failed:", e);
    });
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.debug("trackRouteEvent threw:", e);
  }
}

// Mock-airline placeholders; for real Duffel airlines we use Duffel's CDN-served
// logos at https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/<IATA>.svg
const _MOCK_AL_LOGOS = {
  AL: "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/fb5fed738cc52c7ff0ffe401650da25aed96c98f672f32b9478915cb2045bd03.png",
  GW: "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/207a1a35afae26cc3d5db711286129c6095444fbba29ea5fd1647f31e63196e9.png",
  SP: "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/6ae79d06917c138cc0282c0e205b166f39f1c2ebc30aff39b854ae7eedea46e7.png",
  PA: "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/fb5fed738cc52c7ff0ffe401650da25aed96c98f672f32b9478915cb2045bd03.png",
  AT: "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/207a1a35afae26cc3d5db711286129c6095444fbba29ea5fd1647f31e63196e9.png",
};

export function getAirlineLogo(code) {
  if (!code) return _MOCK_AL_LOGOS.AL;
  if (_MOCK_AL_LOGOS[code]) return _MOCK_AL_LOGOS[code];
  return `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${code}.svg`;
}

// Backwards-compat for the previous import; consumers can use either.
export const AIRLINE_LOGOS = new Proxy(_MOCK_AL_LOGOS, {
  get: (target, prop) => (typeof prop === "string" ? getAirlineLogo(prop) : target[prop]),
});

export function formatDuration(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${h}h ${m.toString().padStart(2, "0")}m`;
}

export function formatPrice(p, currency = "USD") {
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(p);
}

export function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
